import { usageTypeMap } from '@/common/constants';
import { getQueryByLocationSearch } from '@/utils/index';
import { computedPbxPlans } from '@/common/service/computers/plans/pbx';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['addressInfo', 'getSelectedPlans']),
    hasZPPlan() {
      return !!computedPbxPlans(this.getSelectedPlans).length;
    },
  },
  methods: {
    initUsageType() {
      const winUsage = window.$config('usageType');
      if (this.hasZPPlan) {
        return usageTypeMap.business;
      }
      if (this.addressInfo.usageType) {
        return this.addressInfo.usageType;
      }
      if (this.addressInfo.usageType === usageTypeMap.business) {
        return usageTypeMap.business;
      } else if (winUsage && winUsage === usageTypeMap.business) {
        return usageTypeMap.business;
      } else {
        if (getQueryByLocationSearch().usageType === usageTypeMap.business) {
          return usageTypeMap.business;
        }
      }
      return usageTypeMap.personal;
    },
    initFormUsageType(){
        const usageInitType = this.initUsageType()
        if(usageInitType === usageTypeMap.business){
          return usageTypeMap.business
        }
        if (this.addressInfo.usageType) {
          return this.addressInfo.usageType;
        }
        const winUsage = window.$config('usageType');
        if (winUsage && winUsage === usageTypeMap.personal) {
          return usageTypeMap.personal;
        } else {
          const querySearch = getQueryByLocationSearch().usageType
          if(querySearch === usageTypeMap.personal){
            return usageTypeMap.personal;
          }
        }
        return '';
    }
  },
};
